import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth/auth.service';

/**
 * Protects admin routes.
 * Allows access only if user is a global admin/engineer (company_id = null, role = admin|engineer).
 * If tenant user → redirect to /dashboard
 * If not logged in → redirect to /login (handled by authGuard before this one)
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.getUser();
  if (!user) {
    return router.createUrlTree(['/login']);
  }

  const isGlobalAdmin = (user.company_id === null || user.company_id === undefined) &&
    (user.role === 'admin' || user.role === 'engineer');

  if (!isGlobalAdmin) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
